var globals = {}

// Admin API routes are served by this app. Default to the current browser origin;
// keep local development and Azure-hosted deployments independent of the legacy domain.
globals.SERVER_URL = window.location.origin

export { globals }
